var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarReportActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3498 2H9.64977C8.60977 2 7.75977 2.84 7.75977 3.88V4.82C7.75977 5.86 8.59977 6.7 9.63977 6.7H14.3498C15.3898 6.7 16.2298 5.86 16.2298 4.82V3.88C16.2398 2.84 15.3898 2 14.3498 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.24 4.81949C17.24 6.40949 15.94 7.70949 14.35 7.70949H9.65004C8.06004 7.70949 6.76004 6.40949 6.76004 4.81949C6.76004 4.25949 6.16004 3.90949 5.66004 4.16949C4.25004 4.91949 3.29004 6.40949 3.29004 8.11949V17.5295C3.29004 19.9895 5.30004 21.9995 7.76004 21.9995H16.24C18.7 21.9995 20.71 19.9895 20.71 17.5295V8.11949C20.71 6.40949 19.75 4.91949 18.34 4.16949C17.84 3.90949 17.24 4.25949 17.24 4.81949ZM12.38 16.9495H8.00004C7.59004 16.9495 7.25004 16.6095 7.25004 16.1995C7.25004 15.7895 7.59004 15.4495 8.00004 15.4495H12.38C12.79 15.4495 13.13 15.7895 13.13 16.1995C13.13 16.6095 12.79 16.9495 12.38 16.9495ZM15 12.9495H8.00004C7.59004 12.9495 7.25004 12.6095 7.25004 12.1995C7.25004 11.7895 7.59004 11.4495 8.00004 11.4495H15C15.41 11.4495 15.75 11.7895 15.75 12.1995C15.75 12.6095 15.41 12.9495 15 12.9495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarReportActive);
export default __webpack_public_path__ + "static/media/sidebar-report-active.0653e52b1c265004cf92cf51bbcc7b32.svg";
export { ForwardRef as ReactComponent };